<template>
    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-normal" :class="[textColor, bgColor]">
        {{ label }}
    </span>
</template>

<script setup lang="ts">
defineProps<{ label: string; textColor: string; bgColor: string }>();
</script>
